var _path, _mask, _path2, _path3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg401(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 217,
    style: {
      height: 217,
      width: 246
    },
    viewBox: "",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.979 10.75C114.099 -1.58333 131.901 -1.58334 139.022 10.75L241.213 187.75C248.333 200.083 239.432 215.5 225.191 215.5H20.8091C6.56783 215.5 -2.33299 200.083 4.78767 187.75L106.979 10.75Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 163.818C110 156.942 115.575 151.367 122.451 151.367C129.328 151.367 134.902 156.942 134.902 163.818C134.902 170.695 129.328 176.27 122.451 176.27C115.575 176.27 110 170.695 110 163.818Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 163.818C110 156.942 115.575 151.367 122.451 151.367C129.328 151.367 134.902 156.942 134.902 163.818C134.902 170.695 129.328 176.27 122.451 176.27C115.575 176.27 110 170.695 110 163.818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113 163.818C113 158.599 117.231 154.367 122.451 154.367L122.451 148.367C113.918 148.367 107 155.285 107 163.818L113 163.818ZM122.451 154.367C127.671 154.367 131.902 158.599 131.902 163.818L137.902 163.818C137.902 155.285 130.985 148.367 122.451 148.367L122.451 154.367ZM131.902 163.818C131.902 169.038 127.671 173.27 122.451 173.27L122.451 179.27C130.985 179.27 137.902 172.352 137.902 163.818L131.902 163.818ZM122.451 173.27C117.231 173.27 113 169.038 113 163.818L107 163.818C107 172.352 113.918 179.27 122.451 179.27L122.451 173.27Z",
    fill: "black",
    mask: "url(#path-2-inside-1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 128.963,
    y: 144.158,
    width: 14.7561,
    height: 42.6585,
    rx: 5.5,
    transform: "rotate(180 128.963 144.158)",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg401);
export default __webpack_public_path__ + "static/media/401.3082a379.svg";
export { ForwardRef as ReactComponent };